// remembr i18n — supports 13 locales (EN + 12 translated, incl. Korean).
// Detection order: localStorage → browser default → EN fallback.
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import zh from "./locales/zh.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import de from "./locales/de.json";
import it from "./locales/it.json";
import ja from "./locales/ja.json";
import ko from "./locales/ko.json";
import pt from "./locales/pt.json";
import el from "./locales/el.json";
import tl from "./locales/tl.json";
import hi from "./locales/hi.json";
import ar from "./locales/ar.json";

export const SUPPORTED_LOCALES = [
    { code: "en", label: "English",      native: "English" },
    { code: "zh", label: "Mandarin",     native: "中文" },
    { code: "es", label: "Spanish",      native: "Español" },
    { code: "fr", label: "French",       native: "Français" },
    { code: "de", label: "German",       native: "Deutsch" },
    { code: "it", label: "Italian",      native: "Italiano" },
    { code: "ja", label: "Japanese",     native: "日本語" },
    { code: "ko", label: "Korean",       native: "한국어" },
    { code: "pt", label: "Portuguese",   native: "Português" },
    { code: "el", label: "Greek",        native: "Ελληνικά" },
    { code: "tl", label: "Filipino",     native: "Filipino" },
    { code: "hi", label: "Hindi",        native: "हिन्दी" },
    { code: "ar", label: "Arabic",       native: "العربية" },
];

const resources = {
    en: { translation: en },
    zh: { translation: zh },
    es: { translation: es },
    fr: { translation: fr },
    de: { translation: de },
    it: { translation: it },
    ja: { translation: ja },
    ko: { translation: ko },
    pt: { translation: pt },
    el: { translation: el },
    tl: { translation: tl },
    hi: { translation: hi },
    ar: { translation: ar },
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: "en",
        supportedLngs: SUPPORTED_LOCALES.map((l) => l.code),
        detection: {
            order: ["localStorage", "navigator"],
            caches: ["localStorage"],
            lookupLocalStorage: "reminissing.locale",
        },
        interpolation: { escapeValue: false },
        returnObjects: true,
    });

export default i18n;
